import icons from 'src/utils/icons';

export enum EPublisherName {
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google Maps',
  BING = 'Bing',
  APPLE_MAPS = 'Apple Maps',
  YELP = 'Yelp',
  INSTAGRAM = 'Instagram',
  WAZE = 'Waze',

  // TODO Valori non controllati
  TRIPADVISOR = 'TripAdvisor',
  TRIPADVISOR_ATTRACTIONS = 'TripAdvisor Attractions',
  DEALERRATER = 'DealerRater',
  MERCHANTCIRCLE = 'MerchantCircle',
  OPENTABLE = 'OpenTable',
  YELLOWBOOK = 'YellowBook',
  TRULIA = 'Trulia',
  REACH150 = 'Reach150',
  REALTOR = 'Realtor.com',
  ZILLOW = 'Zillow',
  CITYSEARCH = 'Citysearch',

  //? Listing Pro
  AGODA = 'Agoda',
  BE_LOCAL_FOCUSSED = 'Be Local Focussed',
  BIZMETRON = 'Bizmetron',
  CITY_OPTIMUM = 'City Optimum',
  DUCK_DUCK_GO = 'DuckDuckGo',
  ENROLL_BUSINESS = 'Enroll Business',
  GALACTIC_VIBE = 'Galactic Vibe',
  GEOCACHING = 'Geocaching',
  GO_LOCAL_PAGES = 'Go Local Pages',
  HOTFROG = 'Hotfrog',
  IGLOBAL = 'iGlobal',
  INFOBEL = 'Infobel',
  JOOM_LOCAL = 'Joom Local',
  LIME = 'Lime',
  LOCAL_LIST_360 = 'Local List 360',
  LOCAL469 = 'Local469',
  LOCALIZED_LISTINGS = 'Localized Listings',
  LOCL_FOCUS = 'Locl Focus',
  MAP_QUEST = 'MapQuest',
  MY_BIZ_WINNER = 'My Biz Winner',
  MY_LOCAL_EDGE = 'My Local Edge',
  NET_LOCAL_BIZ = 'Net Local Biz',
  OPENDI_US = 'Opendi US',
  PRO_SEARCH_DIRECTORY = 'Pro Search Directory',
  RUNTASTIC = 'Runtastic',
  SEDIORA = 'Sediora',
  SHOW_ME_LOCAL = 'Show Me Local',
  SMART_BUSINESS_SEARCH = 'Smart Business Search',
  SPEEDY_LOCAL = 'Speedy Local',
  UBER = 'Uber',
  YP_LISTING = 'YP Listing',
  ZOOM_LOCAL_SEARCH = 'Zoom Local Search',

  //? Social Hub
  TWITTER = 'Twitter',
  LINKEDIN = 'LinkedIn',
  PINTEREST = 'Pinterest',
  TUMBLR = 'Tumblr',
  YOUTUBE = 'YouTube',
  TIKTOK = 'TikTok',
}

/**
 * Publisher rimossi dal catalogo Synup (ottobre 2026).
 * Il BE puo ancora restituirli sulle listing gia esistenti, quindi la lista serve
 * anche a runtime per tenerli fuori dalla UI di Listing.
 */
export const REMOVED_LISTING_PUBLISHERS: readonly string[] = [
  'Yellow Bot',
  'Chamber Of Commerce',
  'Tupalo',
  'EZLocal',
  'US City',
  'iBegin',
  'Judys Book',
  'EBusiness Pages',
  'MyLocalServices',
  'Foursquare',
  'N49',
  'Localtunity',
  'MerchantsNearby',
  'Local Mint',
  'Lyft',
  'SuperPages',
  'YellowPages',
  'DexKnows',
  'CitySquares',
  'InsiderPages',
  'eLocal',
  'Jersey Shore VIP',
  'Date on Deals',
  'Moorestown VIP',
  'Your Town VIP',
  'Swarm',
  'Data-Axle',
  'Neustarlocaleze',
  'BubbleLife',
  'botw',
  'arrivebusiness',
  'Wheretoapp',
];

// Synup e il BE scrivono lo stesso publisher con spaziature e trattini diversi
// ("Data Axle" / "Data-Axle", "Where To App" / "Wheretoapp"): confronto normalizzato.
const normalizePublisherName = (name: string) => name.toLowerCase().replaceAll(/[^a-z0-9]/g, '');

const removedListingPublisherKeys = new Set(REMOVED_LISTING_PUBLISHERS.map(normalizePublisherName));

/**
 * Dice se un publisher e stato rimosso dal catalogo Synup.
 *
 * @param name - Nome del publisher come arriva dal BE (site.name).
 * @returns true quando il publisher non fa piu parte del catalogo.
 */
export const isRemovedListingPublisher = (name: string) =>
  removedListingPublisherKeys.has(normalizePublisherName(name));

export enum ESiteName {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
}

export const PublisherIcons: {
  [key in EPublisherName]: string;
} = {
  [EPublisherName.FACEBOOK]: icons.publishers.facebook,
  [EPublisherName.GOOGLE]: icons.publishers.google,
  [EPublisherName.BING]: icons.publishers.bing,
  [EPublisherName.APPLE_MAPS]: icons.publishers.appleMaps,
  [EPublisherName.YELP]: icons.publishers.yelp,
  [EPublisherName.INSTAGRAM]: icons.publishers.instagram,
  [EPublisherName.WAZE]: icons.publishers.waze,
  [EPublisherName.TRIPADVISOR]: icons.publishers.tripAdvisor,

  //? Social Hub
  [EPublisherName.TWITTER]: icons.publishers.twitter,
  [EPublisherName.LINKEDIN]: icons.publishers.linkedin,
  [EPublisherName.PINTEREST]: icons.publishers.pinterest,
  [EPublisherName.TUMBLR]: icons.publishers.tumblr,
  [EPublisherName.YOUTUBE]: icons.publishers.youtube,
  [EPublisherName.TIKTOK]: icons.publishers.tiktok,

  //? Listing Pro
  [EPublisherName.TRIPADVISOR_ATTRACTIONS]: icons.publishers.placeholder,
  [EPublisherName.DEALERRATER]: icons.publishers.placeholder,
  [EPublisherName.MERCHANTCIRCLE]: icons.publishers.placeholder,
  [EPublisherName.OPENTABLE]: icons.publishers.placeholder,
  [EPublisherName.YELLOWBOOK]: icons.publishers.placeholder,
  [EPublisherName.TRULIA]: icons.publishers.placeholder,
  [EPublisherName.REACH150]: icons.publishers.placeholder,
  [EPublisherName.REALTOR]: icons.publishers.placeholder,
  [EPublisherName.ZILLOW]: icons.publishers.zillow,
  [EPublisherName.CITYSEARCH]: icons.publishers.placeholder,
  [EPublisherName.AGODA]: icons.publishers.placeholder,
  [EPublisherName.BE_LOCAL_FOCUSSED]: icons.publishers.placeholder,
  [EPublisherName.BIZMETRON]: icons.publishers.placeholder,
  [EPublisherName.CITY_OPTIMUM]: icons.publishers.placeholder,
  [EPublisherName.DUCK_DUCK_GO]: icons.publishers.placeholder,
  [EPublisherName.ENROLL_BUSINESS]: icons.publishers.placeholder,
  [EPublisherName.GALACTIC_VIBE]: icons.publishers.placeholder,
  [EPublisherName.GEOCACHING]: icons.publishers.placeholder,
  [EPublisherName.GO_LOCAL_PAGES]: icons.publishers.placeholder,
  [EPublisherName.HOTFROG]: icons.publishers.placeholder,
  [EPublisherName.IGLOBAL]: icons.publishers.placeholder,
  [EPublisherName.INFOBEL]: icons.publishers.placeholder,
  [EPublisherName.JOOM_LOCAL]: icons.publishers.placeholder,
  [EPublisherName.LIME]: icons.publishers.placeholder,
  [EPublisherName.LOCAL_LIST_360]: icons.publishers.placeholder,
  [EPublisherName.LOCAL469]: icons.publishers.placeholder,
  [EPublisherName.LOCALIZED_LISTINGS]: icons.publishers.placeholder,
  [EPublisherName.LOCL_FOCUS]: icons.publishers.placeholder,
  [EPublisherName.MAP_QUEST]: icons.publishers.placeholder,
  [EPublisherName.MY_BIZ_WINNER]: icons.publishers.placeholder,
  [EPublisherName.MY_LOCAL_EDGE]: icons.publishers.placeholder,
  [EPublisherName.NET_LOCAL_BIZ]: icons.publishers.placeholder,
  [EPublisherName.OPENDI_US]: icons.publishers.placeholder,
  [EPublisherName.PRO_SEARCH_DIRECTORY]: icons.publishers.placeholder,
  [EPublisherName.RUNTASTIC]: icons.publishers.placeholder,
  [EPublisherName.SEDIORA]: icons.publishers.placeholder,
  [EPublisherName.SHOW_ME_LOCAL]: icons.publishers.placeholder,
  [EPublisherName.SMART_BUSINESS_SEARCH]: icons.publishers.placeholder,
  [EPublisherName.SPEEDY_LOCAL]: icons.publishers.placeholder,
  [EPublisherName.UBER]: icons.publishers.placeholder,
  [EPublisherName.YP_LISTING]: icons.publishers.placeholder,
  [EPublisherName.ZOOM_LOCAL_SEARCH]: icons.publishers.placeholder,
};

export const PublisherSiteUrl: {
  [key in EPublisherName]: string;
} = {
  [EPublisherName.GOOGLE]: 'maps.google.com',
  [EPublisherName.FACEBOOK]: 'facebook.com',
  [EPublisherName.YELP]: 'yelp.com',
  [EPublisherName.TRIPADVISOR]: 'tripadvisor.com',
  [EPublisherName.TRIPADVISOR_ATTRACTIONS]: 'tripadvisor-attractions.com',
  [EPublisherName.DEALERRATER]: 'dealerrater.com',
  [EPublisherName.MERCHANTCIRCLE]: 'merchantcircle.com',
  [EPublisherName.OPENTABLE]: 'opentable.com',
  [EPublisherName.YELLOWBOOK]: 'yellowbook.com',
  [EPublisherName.TRULIA]: 'trulia.com',
  [EPublisherName.REACH150]: 'reach150.com',
  [EPublisherName.REALTOR]: 'realtor.com',
  [EPublisherName.ZILLOW]: 'zillow.com',
  [EPublisherName.CITYSEARCH]: 'citysearch.com',

  //? Listing Pro
  [EPublisherName.BING]: '',
  [EPublisherName.APPLE_MAPS]: '',
  [EPublisherName.INSTAGRAM]: '',
  [EPublisherName.WAZE]: '',
  [EPublisherName.AGODA]: '',
  [EPublisherName.BE_LOCAL_FOCUSSED]: '',
  [EPublisherName.BIZMETRON]: '',
  [EPublisherName.CITY_OPTIMUM]: '',
  [EPublisherName.DUCK_DUCK_GO]: '',
  [EPublisherName.ENROLL_BUSINESS]: '',
  [EPublisherName.GALACTIC_VIBE]: '',
  [EPublisherName.GEOCACHING]: '',
  [EPublisherName.GO_LOCAL_PAGES]: '',
  [EPublisherName.HOTFROG]: '',
  [EPublisherName.IGLOBAL]: '',
  [EPublisherName.INFOBEL]: '',
  [EPublisherName.JOOM_LOCAL]: '',
  [EPublisherName.LIME]: '',
  [EPublisherName.LOCAL_LIST_360]: '',
  [EPublisherName.LOCAL469]: '',
  [EPublisherName.LOCALIZED_LISTINGS]: '',
  [EPublisherName.LOCL_FOCUS]: '',
  [EPublisherName.MAP_QUEST]: '',
  [EPublisherName.MY_BIZ_WINNER]: '',
  [EPublisherName.MY_LOCAL_EDGE]: '',
  [EPublisherName.NET_LOCAL_BIZ]: '',
  [EPublisherName.OPENDI_US]: '',
  [EPublisherName.PRO_SEARCH_DIRECTORY]: '',
  [EPublisherName.RUNTASTIC]: '',
  [EPublisherName.SEDIORA]: '',
  [EPublisherName.SHOW_ME_LOCAL]: '',
  [EPublisherName.SMART_BUSINESS_SEARCH]: '',
  [EPublisherName.SPEEDY_LOCAL]: '',
  [EPublisherName.UBER]: '',
  [EPublisherName.YP_LISTING]: '',
  [EPublisherName.ZOOM_LOCAL_SEARCH]: '',

  //? Social Hub
  [EPublisherName.TWITTER]: '',
  [EPublisherName.LINKEDIN]: '',
  [EPublisherName.PINTEREST]: '',
  [EPublisherName.TUMBLR]: '',
  [EPublisherName.YOUTUBE]: '',
  [EPublisherName.TIKTOK]: '',
};

export const getPublisherIconFromURL = (publisherUrl: string) => {
  const target = Object.entries(PublisherSiteUrl).find((x) => x[1] === publisherUrl);
  return getPublisherIcon(target ? (target[0] as EPublisherName) : undefined);
};

export const getPublisherNameFromURL = (publisherUrl: string) => {
  const target = Object.entries(PublisherSiteUrl).find((x) => x[1] === publisherUrl);
  return target ? (target[0] as EPublisherName) : publisherUrl;
};

export const getPublisherIcon = (publisherName: EPublisherName | undefined) => {
  if (publisherName === ('Google My Business' as EPublisherName)) {
    publisherName = EPublisherName.GOOGLE;
  }

  const isSocialHub = [
    EPublisherName.TWITTER,
    EPublisherName.LINKEDIN,
    EPublisherName.PINTEREST,
    EPublisherName.TUMBLR,
    EPublisherName.YOUTUBE,
    EPublisherName.TIKTOK,
    EPublisherName.INSTAGRAM,
    EPublisherName.FACEBOOK,
  ].includes(publisherName as EPublisherName);

  const icon = {
    icon: publisherName ? PublisherIcons[publisherName] : '',
    color: 'gray',
    isIconify: isSocialHub,
  };

  if (!icon.icon) icon.icon = icons.publishers.placeholder;

  switch (publisherName) {
    case EPublisherName.YELP:
      icon.color = 'red';
      break;
    case EPublisherName.WAZE:
      icon.color = 'blue';
      break;
    case EPublisherName.TUMBLR:
      icon.color = '#314358';
      break;
    case EPublisherName.TWITTER:
      icon.color = 'black';
      break;
  }
  return icon;
};

export enum ESourceUrl {
  google = 'maps.google.com',
  facebook = 'facebook.com',
  yellowpages = 'yellowpages.com',
  judysbook = 'judysbook.com',
  foursquare = 'foursquare.com',
  zillow = 'zillow.com',
  dealerrater = 'dealerrater.com',
  cars = 'cars.com',
  edmunds = 'edmunds.com',
  trustpilot = 'trustpilot.com',
  bbb = 'bbb.org',
  indeed = 'indeed.com',
  cargurus = 'cargurus.com',
  tripadvisor = 'tripadvisor.com',
  tripadvisorAttractions = 'tripadvisor-attractions.com',
  glassdoor = 'glassdoor.com',
  opentable = 'opentable.com',
  zomato = 'zomato.com',
}
